export const setFavicon = (href: string) => {
  let link = document.querySelector<HTMLLinkElement>("link[rel='icon']");

  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }

  link.type = href.endsWith(".ico") ? "image/x-icon" : "image/png";
  link.href = href;
};
